// Deploy stage, defined at build time by vite.config.mjs (APP_ENV).
// process.env.NODE_ENV only says development|production and belongs to Vite.
const APP_ENV = process.env.APP_ENV
export const production = APP_ENV === 'production'
export const staging = APP_ENV === 'staging'
export const development = APP_ENV === 'development'
export const local = APP_ENV === 'local'

// Beta Features
export const isPricingScoreEnabled = () => true
export const isPricingScoreDisabled = () => !isPricingScoreEnabled()

// Localhost detection (runtime, covers all local dev scripts)
const isLocalhost = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.endsWith('.localhost'))

// Logging — PostHog covers dev/staging/production (excluding localhost)
export const isPosthogEnabled = () =>
  !isLocalhost() && (staging || development || production)
export const posthogLoggingEnabled = () => isPosthogEnabled()

export const consoleLogsEnabled = () => staging || development || local
export const breadcrumbsEnabled = () => true
